export default __webpack_public_path__ + "static/media/music.06e4f825.jpeg";